<template>
  <div id="unit-results">
    <div
      v-for="(unit, key) in units"
      :key="key"
      @click="toggleUnitResults"
    >
      <UnitResult v-if="!small" :unit="unit" :expanded="activeUnit==unit.id" :interested="!!interestedUnits[unit.stock_number]" @activateResult="activateResult"></UnitResult>
      <SmallUnitResult v-else :unit="unit" :interested="!!interestedUnits[unit.stock_number]" ></SmallUnitResult>
    </div>
  </div>
</template>

<script setup>
import UnitResult from "./UnitResult.vue";
import SmallUnitResult from "./SmallUnitResult.vue";
import { useSearchResultsStore } from "@/stores/useSearchResultsStore";
import { ref, watch } from "vue";
import { storeToRefs } from "pinia";

const props = defineProps({
  units: { type: Object || null },
  small: { type: Boolean }
});

const searchResultsStore = useSearchResultsStore();
const { interestedUnits } = storeToRefs(searchResultsStore);
const activeUnit = ref(null);

const collapseUnitResultEmit = defineEmits(["collapseUnitResult"]);

// Whenever there is a new set of units, make sure no unit has the expanded swiper
watch(props.units, () => {
  activeUnit.value = null;
});

function toggleUnitResults() {
  collapseUnitResultEmit("collapseUnitResult");
}

function activateResult(id) {
  activeUnit.value = id;
}
</script>

<style scoped>
#unit-results {
  display: flex;
  flex-wrap: nowrap;
  overflow-x: auto;
  width: 100%;
  margin-top: 10px;
  padding-bottom: 10px;
}

#unit-results::-webkit-scrollbar {
  height: 5px;
}

#unit-results::-webkit-scrollbar-track {
  margin: 24px;
}

#unit-results::-webkit-scrollbar-thumb {
  background: #dedddf;
  border-radius: 1px;
}

#unit-results > :last-child {
  margin-right: 15px;
}

@media (max-width: 768px) {
  #unit-results {
    -ms-overflow-style: none; /* IE and Edge */
    scrollbar-width: none;
  }
}
</style>
